import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {ValueDisplayable} from "../modules/ui/interface/value.displayable";

@JacksonType("IndicadorOperacaoIBSCBS")
@JsonIdentityInfo()
export class IndicadorOperacaoIBSCBS extends SonnerBaseEntity implements ValueDisplayable{

  id: number;

  codigo: string;

  cacteristica: string;

  localFornecimento: string;

  getDisplayValue(): string {
    return this.codigo + " - " + this.cacteristica + " - " + this.localFornecimento;
  }

}
